export const enum EncounterTypeEnum {
  ApprovedEncounter = 1,
  GeneratesEncounter = 2,
  DoesNotGenerateEncounters = 3,
}



// WEBPACK FOOTER //
// ./src/app/core/enums/encounter-type.enum.ts